import {useParams} from 'react-router-dom';

import {Stack} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useNotificationSubscription} from '../hooks/useNotificationSubscription.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';


export const EditPage = () => {

    const {id: notificationSubscriptionId} = useParams();

    if (typeof notificationSubscriptionId === 'undefined') {
        throw new Error('notificationSubscriptionId is required parameter');
    }

    const {
        record: notificationSubscription,
        updateRecord,
        loading,
    } = useNotificationSubscription(notificationSubscriptionId);

    const {
        mode,
        tools,
    } = useEditPageTools();

    if (loading || !notificationSubscription) {
        return <PlatformLoader message='Loading notificationSubscription...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={notificationSubscription.endpoint ? notificationSubscription.endpoint : notificationSubscription.id}
            pageNavigation={<EditPageNavigation component={notificationSubscription}/>}
            tools={tools}
        >

            {mode === 'view' ?
                <Stack gap='lg'>
                    <Profile
                        record={notificationSubscription}
                    />
                </Stack>
                :
                <RecordForm
                    record={notificationSubscription}
                    handleSubmit={updateRecord}
                />}

        </FormPageLayout>
    );
};
